<template>
    <div>
        <el-dialog
                center
                title="Service Options"
                :visible.sync="selfVisible"
                :close-on-click-modal="false"
                width="800px">
            <div>
                <div v-for="(question,index) in data" :key="index" style="margin-top: 10px">
                    <el-input v-model="question.title" placeholder="Enter service options" style="width: 400px"></el-input>

                    <el-button type="warning" v-show="index===0" size="small" style="margin-left: 0"
                               icon="el-icon-plus" @click="data.push({options:[{}],title:''})">
                    </el-button>

                    <el-button type="danger" v-if="index!==0" size="small" style="margin-left: 0"
                               icon="el-icon-delete" @click="removeOption(index)">
                    </el-button>

                    <div v-for="(option,oIndex) in question.options" :key="oIndex">
                        <el-input placeholder="Options" style="width: 400px" v-model="option.value">
                            <template slot="prepend">Value</template>
                            <template slot="append">$</template>
                        </el-input>

                        <el-input-number v-model="option.price" :min="0">
                            <template slot="prepend">Price</template>
                        </el-input-number>

                        <el-button type="danger" icon="el-icon-delete" :disabled="question.options.length ===1"
                                   style="margin-left: 1%" size="small"
                                   @click="removeValue(index,oIndex)">
                        </el-button>

                        <el-button type="warning" icon="el-icon-plus" v-if="oIndex ===0" style="margin-left: 1%"
                                   size="small"
                                   @click="question.options.push({})">
                        </el-button>
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="save">Save</el-button>
                <el-button @click="selfVisible = false">Cancel</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {serviceOptions, updateServiceOptions} from '@/api/HomeserviceApi'

    export default {
        name: 'CommServiceOptionUpdate',
        props: {serviceId: {required: true}, visible: {required: true}},
        data() {
            return {
                data: {},
                selfVisible: this.selfVisible ? this.selfVisible : this.visible
            }
        },
        methods: {
            removeOption(index) {
                if (confirm('Confirm remove this items?')) {
                    this.data.splice(index, 1)
                }
            },
            removeValue(optionIndex, ValueIndex) {
                let ops = this.data[optionIndex].options
                if (confirm('Confirm remove this items?')) {
                    ops.splice(ValueIndex, 1)
                }
            },
            save() {
                updateServiceOptions(this.data, this.serviceId).then(res => {
                    if (res.status === 200) {
                        this.$msg.success('Success')
                        this.selfVisible = false
                    }
                })
            },
            loadData() {
                serviceOptions(this.serviceId)
                    .then(res => {
                        if (res.data.length === 0) {
                            this.data = [{options: [{}]}]
                        } else {
                            this.data = res.data
                        }
                    })
            }
        },
        watch: {
            'selfVisible': function (val) {
                this.$emit('update:visible', val)
            }
        },
        mounted() {
            this.loadData()
        }
    }
</script>

<style scoped>
    .el-input{
        margin: 0 5px 5px 0;
    }
</style>
